import { SourceControlProvider, SourceControl } from "@modules/graphql/types"
import { LoginOption } from "@modules/user/shared/constants"

export function isConnectedWithGithub(providers?: SourceControl[]) {
  return providers?.some(
    item => item.source === SourceControlProvider.Github && item.connected
  )
}

export const mapProviderToLoginOption: Record<
  SourceControlProvider,
  LoginOption
> = {
  [SourceControlProvider.Github]: LoginOption.Github,
  [SourceControlProvider.GithubEnterprise]: LoginOption.GithubEnterprise,
  [SourceControlProvider.Gitlab]: LoginOption.Gitlab,
  [SourceControlProvider.Bitbucket]: LoginOption.Bitbucket,
  [SourceControlProvider.Google]: LoginOption.Google,
  [SourceControlProvider.Workos]: LoginOption.Workos,
  [SourceControlProvider.GitlabSelfManaged]: LoginOption.GitlabSelfManaged,
}

export function isGithubOrGithubEnterprise(source?: SourceControlProvider) {
  return (
    source &&
    [
      SourceControlProvider.GithubEnterprise,
      SourceControlProvider.Github,
    ].includes(source)
  )
}

export function isSelfHosted(source?: SourceControlProvider | null) {
  return (
    source &&
    [
      SourceControlProvider.GithubEnterprise,
      SourceControlProvider.GitlabSelfManaged,
    ].includes(source)
  )
}

export function getPathToCreateSite(organizationId?: string) {
  return organizationId
    ? `/dashboard/organization/${organizationId}/sites/create`
    : `/dashboard/sites/create`
}

export function getPathToSelfHostedSettings(organizationId?: string) {
  return organizationId
    ? `/dashboard/organization/${organizationId}/settings/general#selfHostedGit`
    : null
}
export function getPathToImportSite(
  organizationId?: string,
  rootPath = `dashboard`
) {
  return organizationId
    ? `/${rootPath}/organization/${organizationId}/sites/import`
    : `/${rootPath}/sites`
}

export function getPathToDeployNowSite(organizationId: string) {
  return organizationId
    ? `/dashboard/organization/${organizationId}/sites/deploynow`
    : `/dashboard/sites`
}

export function getPathToSelectProvider(organizationId: string) {
  return organizationId
    ? `/dashboard/organization/${organizationId}/sites/import/repository`
    : `/dashboard/sites`
}

export function getPathToProvisionSite(organizationId?: string) {
  return organizationId
    ? `/dashboard/organization/${organizationId}/sites/provision`
    : `/dashboard/sites`
}
